import { cn } from "@newxsystems/shared";
import { StratosAction } from "../StratosAction/StratosAction";
import { StratosRichText } from "../StratosRichText/StratosRichText";
import type { IStratosCommonContentProps } from "./StratosCommonContent.props";

export const StratosCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: IStratosCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  const Heading = headingAs;
  const centered = alignment === "center";
  const actions = buttons;

  return (
    <div
      className={cn(
        "flex max-w-[52rem] flex-col gap-6",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "flex w-fit items-center gap-3 font-stratos-body text-sm font-semibold leading-[1.4] text-primary before:h-px before:w-10 before:bg-current",
            tone === "dark" && "text-sunlit",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "max-w-[18ch] font-stratos-display text-4xl font-bold leading-[0.94] tracking-[-0.04em] text-balance text-foreground [overflow-wrap:anywhere] md:text-[3.25rem]",
            tone === "dark" && "text-cloud-white",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <StratosRichText
          className={cn(
            "max-w-[65ch]",
            tone === "dark" &&
              "text-cloud-white [&_a]:text-cloud-white [&_blockquote]:border-cloud-white/40 [&_blockquote]:text-cloud-white",
          )}
          content={description}
        />
      ) : null}
      {actions?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
          {actions.map((button, index) => (
            <StratosAction
              action={button}
              className={tone === "dark" ? "border-cloud-white text-cloud-white" : undefined}
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

StratosCommonContent.displayName = "Content::StratosCommonContent";
